var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #667085;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m52.39,24.75H11.61c-1,0-1.81-.81-1.81-1.81v-6.8c0-1.08.44-2.13,1.2-2.89.77-.77,1.79-1.19,2.88-1.19h36.26c1.09,0,2.11.42,2.88,1.19.76.76,1.19,1.81,1.19,2.88v6.8c0,1-.81,1.81-1.81,1.81Zm-38.97-3.63h37.16v-4.99c0-.12-.05-.24-.13-.32-.08-.08-.2-.13-.32-.13H13.87c-.12,0-.23.05-.32.13-.09.09-.13.2-.13.32v4.99Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m37.66,36.08h-11.33c-1,0-1.81-.81-1.81-1.81s.81-1.81,1.81-1.81h11.33c1,0,1.81.81,1.81,1.81s-.81,1.81-1.81,1.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m47.86,51.94h-31.72c-1.07,0-2.12-.44-2.88-1.2-.77-.77-1.2-1.79-1.2-2.88v-24.93c0-1,.81-1.81,1.81-1.81h36.26c1,0,1.81.81,1.81,1.81v24.93c0,1.09-.42,2.11-1.19,2.88-.77.77-1.8,1.2-2.88,1.2ZM15.69,24.75v23.11c0,.12.05.23.13.32.09.09.2.14.32.14h31.72c.12,0,.23-.05.32-.13.08-.08.13-.2.13-.32v-23.11H15.69Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.369005c42c7614e04b7bd2ef31b0c631.svg";
export { ForwardRef as ReactComponent };